import * as React from "react";
import { compose, mapProps } from "recompose";
import { renderWhileLoading } from "~/util/renderWhileLoading";

import Loader from "~/components/TrackTrace/Loader";
import NexusShipmentDetail from "~/components/TrackTrace/NexusShipmentDetail";
import NotFound from "~/components/TrackTrace/NotFound";

import { NetworkStatus } from "apollo-client";
import {
  IInputProps as IOrderInputProps,
  IResponseProps as IOrderResponseProps,
  withOrderByName
} from "~/graphql/queries/order/orderByName";

class NexusShipmentStatusContainer extends React.Component<
  IOrderResponseProps & IOrderInputProps
> {
  public render() {
    const {
      orderNumber,
      postalCode,
      orderByNameQuery: { orderByName, networkStatus }
    } = this.props;

    if (orderByName && networkStatus === NetworkStatus.ready) {
      return <NexusShipmentDetail order={orderByName} />;
    }

    return <NotFound orderNumber={orderNumber} postalCode={postalCode} />;
  }
}

export default compose<IOrderResponseProps, IOrderInputProps>(
  withOrderByName,
  renderWhileLoading(Loader, "orderByNameQuery"),
  mapProps((props: IOrderResponseProps) => ({
    ...props
  }))
)(NexusShipmentStatusContainer);



// WEBPACK FOOTER //
// ./src/containers/TrackTrace/NexusShipmentStatusContainer.tsx